import * as React from 'react';

// TODO: remove this component once the teacher icon is being added to CDS icons.
const TeacherIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6304_25133)">
        <path d="M22.5 1.5H1.5V3H22.5V1.5Z" fill="black" />
        <path
          d="M21.75 4.5H2.25C1.8375 4.5 1.5 4.8375 1.5 5.25V18H3V6H21V16.5H15.9525C14.895 15.57 13.515 15 12 15C10.485 15 9.105 15.57 8.0475 16.5H4.5V18H6.81C6.3 18.885 6 19.905 6 21H1.5V22.5H22.5V21H18C18 19.905 17.7 18.885 17.19 18H21.75C22.1625 18 22.5 17.6625 22.5 17.25V5.25C22.5 4.8375 22.1625 4.5 21.75 4.5ZM7.5 21C7.5 18.5175 9.5175 16.5 12 16.5C14.4825 16.5 16.5 18.5175 16.5 21H7.5Z"
          fill="black"
        />
        <path
          d="M15.375 10.875C15.375 9.015 13.86 7.5 12 7.5C10.14 7.5 8.625 9.015 8.625 10.875C8.625 12.735 10.14 14.25 12 14.25C13.86 14.25 15.375 12.735 15.375 10.875ZM10.125 10.875C10.125 9.84 10.965 9 12 9C13.035 9 13.875 9.84 13.875 10.875C13.875 11.91 13.035 12.75 12 12.75C10.965 12.75 10.125 11.91 10.125 10.875Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_6304_25133">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TeacherIcon;
